module.exports = __webpack_public_path__ + "fd64bdef4e817b2fe0e5c521ced45d08.png";